/**
 * @module app.core
 */

import { autoinject } from "aurelia-framework";
import { Api } from 'app/shared/lib/api/api';
import { IQueryLoadOptions, IApiQueryResults } from 'app/shared/lib/api/api-types';
import { IQueuesConfig } from 'app/core/models/essette-interfaces';
import * as Core from 'app/core/models/essette-api';
import * as CD from 'app/cd/models/essette-api';


const defaultConfig: IQueuesConfig = {
    serviceRootUrl: ""  // root of "Core" queries
}

@autoinject
export class QueueService {

    ////****************** Fields and Properties ************************************////
    public isConfigured: boolean = false;
    public config: IQueuesConfig;


    ////****************** Functions ************************************************////
    constructor(private readonly api: Api) {
        this.config = defaultConfig;
    }

    public configure(config: IQueuesConfig): void {
        this.config = Object.assign({}, defaultConfig, config);
        this.isConfigured = true;
    }
    private checkConfiguration(): void {
        if(!this.isConfigured) {
            throw Error("Queue service requires module-specific configuration! Use configure() method.");
        }
    }


    ////****************** Queries **************************************************////
    public async loadQueues(delegatedTypeCode: string | null, options?: Partial<IQueryLoadOptions>, includes: string[] = [], fields: string[] = []): Promise<IApiQueryResults<Core.Queue>> {
        this.checkConfiguration();
        const query = this.api
            .query(`${this.config.serviceRootUrl}/queues`)
            .filterString('delegated.type.code', delegatedTypeCode, { ignoreNullValue: true })
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }

    public async loadQueueUsers(queueId: string, options?: Partial<IQueryLoadOptions>, includes: string[] = [], fields: string[] = []): Promise<IApiQueryResults<Core.User>> {
        this.checkConfiguration();
        const query = this.api
            .query(`${this.config.serviceRootUrl}/queues/${queueId}/users`)
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }

    public async loadPortalProviders(memberId: string, options?: Partial<IQueryLoadOptions>, includes: string[] = [], fields: string[] = []): Promise<IApiQueryResults<CD.Provider>> {
        // cd/providers?filter=exists(applications, code+eq+'Portal.Providers')
        const query = this.api
            .query('cd/providers')
            .applyStandardLoadOptions(options)
            .filterExists('portalAssociatedPatients', (f =>
                f.filterIdentifier('id', memberId, { ignoreNullValue: true })
            ))
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }


    ////****************** Loads ****************************************************////
    public async loadQueue(queueId: string, includes: string[] = []) {
        this.checkConfiguration();
        const query = this.api
            .query(`${this.config.serviceRootUrl}/queues/${queueId}`)
            .include(...includes);

        return await this.api.get(query);
    }


    ////****************** Actions **************************************************////

}
